
export enum Methods {
    MOBILEPUSH = "MOBILEPUSH",
    TOTP = "TOTP",
}

